module.exports = __webpack_public_path__ + "img/55_60.6efa01bd.png";